import React, { useState, useEffect } from "react";
import { useWpMenu } from "../hooks/wp/useWpMenu";
import { useWpProjectsSelection } from "../hooks/wp/useWpProjectsSelection";
import { Link } from "gatsby";
import { motion, AnimatePresence } from "framer-motion";
import unslugify from "../utils/unslugify";

const HeaderMobile = ({
  setIsOpen,
  isProjectsOpen,
  isFirstTime,
  setIsFirstTime,
  width,
  isSingleProjectPage,
  pathname,
  setIsAuxMenuVisible,
  auxMenuComponents,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
}) => {
  const {
    wpMenu: {
      menuItems: { nodes: menu },
    },
  } = useWpMenu();
  const {
    wpPage: {
      projectSelection: {
        selection: { nodes: projects },
      },
    },
  } = useWpProjectsSelection();

  const simplerMenuArray = menu.map((item) => item.connectedNode.node);
  const hasProjectPage = simplerMenuArray.findIndex(
    (item) => item.slug === "projects"
  );
  const filteredMenu =
    hasProjectPage > -1
      ? simplerMenuArray.filter((item) => item.slug !== "projects")
      : simplerMenuArray;

  const [isProjectMenuVisible, setIsProjectMenuVisible] = useState(false);

  const toggleProjectMenu = () =>
    setIsProjectMenuVisible(!isProjectMenuVisible);

  const toggleMenu = () => {
    if (isFirstTime) {
      setIsFirstTime(false);
    }
    setIsOpen(true);
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    setIsMobileMenuOpen(false);
    if (pathname.includes("projects")) {
      setIsProjectMenuVisible(true);
    } else {
      setTimeout(() => {
        setIsProjectMenuVisible(false);
      }, 100);
    }
  }, [pathname, setIsMobileMenuOpen]);

  useEffect(() => {
    setIsAuxMenuVisible(true);
  }, [pathname, setIsAuxMenuVisible]);

  useEffect(() => {
    width > 768 && setIsMobileMenuOpen(false);
  }, [width, setIsMobileMenuOpen]);

  const [label, setLabel] = useState("Menu");
  useEffect(() => {
    if (pathname === "/") {
      setLabel("Claudio Majorana");
    } else {
      if (isMobileMenuOpen) {
        setLabel("Claudio Majorana");
      } else {
        setLabel(unslugify(pathname, true));
      }
    }
  }, [pathname, isMobileMenuOpen]);

  return (
    <>
      <header className="px-4 py-3 w-full justify-between font-bold bg-[#ffffff] flex md:hidden text-lg">
        {isMobileMenuOpen ? (
          <Link className="uppercase" to="/">
            {label}
          </Link>
        ) : (
          <span className="uppercase"> {label}</span>
        )}

        <div className="flex flex-row gap-x-2">
          {!isMobileMenuOpen && isSingleProjectPage && (
            <button
              className="uppercase hover:opacity-20 transition-all duration-300 text-left"
              onClick={() => auxMenuComponents.description((prev) => !prev)}
            >
              Read,
            </button>
          )}
          <button onClick={() => toggleMenu()} className="uppercase text-lg">
            {isMobileMenuOpen ? "Close" : "Menu"}
          </button>
        </div>
      </header>
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            className="fixed top-0 left-0 w-full bg-white -z-10 px-4 pt-[calc(52px+.75rem)] pb-4 font-bold text-lg"
            style={{
              height: "calc(100svh)",
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="flex gap-x-2 gap-y-1 flex-wrap">
              <button
                className={`uppercase relative text-left h-min ${
                  isSingleProjectPage || isProjectMenuVisible
                    ? "line-through"
                    : ""
                }`}
                onClick={() =>
                  !isSingleProjectPage ? toggleProjectMenu() : null
                }
              >
                Projects
                {isSingleProjectPage || isProjectMenuVisible ? <>:</> : <>,</>}
              </button>
              {isProjectMenuVisible && (
                <>
                  {projects.map((project, i) => {
                    return (
                      <motion.button
                        key={i}
                        className={`relative text-left h-min break-words`}
                      >
                        <Link
                          to={`/projects/${project.slug}`}
                          className={`uppercase ${
                            pathname.includes(project.slug)
                              ? "line-through"
                              : ""
                          }`}
                        >
                          {project.title}
                          {projects.length - 1 === i ? "," : ","}
                        </Link>
                      </motion.button>
                    );
                  })}
                </>
              )}
              {filteredMenu.map((item, i) => {
                const isCurrent = pathname.includes(item.slug);

                return (
                  <motion.button
                    key={`aux-link-${i}`}
                    className={`relative hover:opacity-20 transition-all duration-300 text-left block
                     ${
                       isProjectsOpen ||
                       (isMobileMenuOpen && isProjectMenuVisible)
                         ? "opacity-20"
                         : "opacity-100"
                     }`}
                  >
                    <Link
                      to={`/${item.slug}/`}
                      className={`uppercase ${isCurrent ? "line-through" : ""}`}
                    >
                      {item.title}
                      {i === filteredMenu.length - 1 ? "." : ","}
                    </Link>
                  </motion.button>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default HeaderMobile;
